import { Rotas } from "constants/EnumRotas";
import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { queryClient } from "shared/util/queryClient";

export const usePostAtivarGroupSign = (codigoSuporte: string) => {
  const navigate = useNavigate();

  const onError = () => {
    toast.error("Erro ao dar início à ativação do Group Sign");
  };

  const onSuccess = () => {
    queryClient.invalidateQueries(["status-ativacao-group-sign"]);
    toast.success("Em breve nosso time comercial entrará em contato");
    navigate(Rotas.ASSINATURA_ATIVACAO_CONCLUIDA);
  };

  return usePost({
    url: api.groupsign.ativarGroupSign,
    onError,
    onSuccess,   
  });
};
